/* Groene Thuisbatterijen — UI Enhancements */

(function () {
  'use strict';

  /* ── 1. HEADER SCROLL GEDRAG ── */
  const header = document.querySelector('.section-header');
  if (header) {
    let lastScroll = 0;
    window.addEventListener('scroll', () => {
      const current = window.scrollY;
      if (current > 80) {
        document.documentElement.classList.add('gtb-scrolled');
      } else {
        document.documentElement.classList.remove('gtb-scrolled');
      }
      lastScroll = current;
    }, { passive: true });
  }

  /* ── 2. TRUST BAR BOVEN FOOTER ── */
  const footer = document.querySelector('footer.footer, footer');
  if (footer) {
    const trustBar = document.createElement('div');
    trustBar.className = 'gtb-trust-bar';
    trustBar.innerHTML = `
      <div class="gtb-trust-bar__inner">
        <div class="gtb-trust-item">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"/></svg>
          <span>14 dagen retour</span>
        </div>
        <div class="gtb-trust-item">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M5 8h14M5 8a2 2 0 110-4h14a2 2 0 110 4M5 8v10a2 2 0 002 2h10a2 2 0 002-2V8m-9 4h4"/></svg>
          <span>Snel geleverd</span>
        </div>
        <div class="gtb-trust-item">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"/></svg>
          <span>Gratis advies</span>
        </div>
        <div class="gtb-trust-item">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M13 10V3L4 14h7v7l9-11h-7z"/></svg>
          <span>Plug-in installatie</span>
        </div>
        <div class="gtb-trust-item">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/><path d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/></svg>
          <span>Veilig betalen</span>
        </div>
      </div>
    `;
    footer.parentNode.insertBefore(trustBar, footer);
  }

  /* ── 3. PRODUCTKAART — "Nieuw" badge voor recente producten ── */
  document.querySelectorAll('.product-card-wrapper').forEach(card => {
    const created = card.dataset.productCreated;
    if (!created) return;
    const days = (Date.now() - new Date(created)) / 86400000;
    if (days < 30) {
      const badge = document.createElement('span');
      badge.className = 'gtb-new-badge';
      badge.textContent = 'Nieuw';
      card.appendChild(badge);
    }
  });

  /* ── 4. SMOOTH SCROLL voor anchor links ── */
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
      const target = document.querySelector(this.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

  /* ── 5. BACK TO TOP snelkoppeling ── */
  const backTop = document.createElement('button');
  backTop.className = 'gtb-back-top';
  backTop.setAttribute('aria-label', 'Terug naar boven');
  backTop.innerHTML = `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M5 15l7-7 7 7"/></svg>`;
  document.body.appendChild(backTop);

  window.addEventListener('scroll', () => {
    backTop.classList.toggle('gtb-back-top--visible', window.scrollY > 400);
  }, { passive: true });

  backTop.addEventListener('click', () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });

})();
